import React, {
    Fragment,
    useEffect,
    useState,
} from "react";
import {
    Input,
    Button,
    FormGroup,
    Label,
    InputGroup,
    FormFeedback
} from "reactstrap";
import { connect } from "react-redux";
import Async from "react-select/async";
import { clearMapNewDeviceError, mapNewDevice } from "../../../store/deviceDetails/actions";
import { copyMasterKeyToClipboard, formatDeviceKeys, getAssignableGroupsForAsyncSelect } from "../../../store/device/actions";
import { updateForm } from "../../../store/form/actions";
import Message from "../../../CommonData/Data/Message";
import VWLoading from "../../../components/vwLoading/vwLoading";

const MapNewDeviceForm = (props) => {

    const { masterDeviceDetails, handleClose, form, errorMessage, isMapNewDevicePending } = props;

    useEffect(() => {
        props.updateForm({
            formMapGroup: {},
            errors: {}
        })
        props.clearMapNewDeviceError();

        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const copyToClipboard = () => {
        const data = masterDeviceDetails && masterDeviceDetails.uid
        props.copyMasterKeyToClipboard(data);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        props.updateForm({
            formMapGroup: {
                ...form.formMapGroup,
                [name]: value
            },
            errors: {
                ...form && form.errors,
                [name]: null,
            }
        });
    }

    const handleLoadGroups = (inputValue, callback) => {
        const { masterDeviceDetails } = props;
        const masterDeviceId = masterDeviceDetails && masterDeviceDetails.id;
        if (masterDeviceId) {
            props.getAssignableGroupsForAsyncSelect(masterDeviceId, inputValue, callback)
        }
        else {
            callback([]);
        }
    };

    const AddGroupChange = (value) => {
        props.updateForm({
            formMapGroup: {
                ...form.formMapGroup,
                new_group: value
            },
            errors: {
                ...form && form.errors,
                new_group: null,
            }
        });
    }

    const handleMapNewDevice = () => {
        const { masterDeviceDetails } = props;
        const { slaveCountToConnect, assignedDevices } = masterDeviceDetails;
        const { formMapGroup } = form || {};
        const { deviceKeys } = formMapGroup || {};
        const currentErrors = {};

        const selectedDeviceKeys = form && form.formMapGroup && form.formMapGroup.deviceKeys;
        const separatedDeviceKeys = formatDeviceKeys(selectedDeviceKeys);
        const deviceKeysSize = separatedDeviceKeys && separatedDeviceKeys.length;
        const mappedSlaveDevices = assignedDevices && assignedDevices.filter((device) => device.deviceTypeFlag !== "M");
        const mappedSlaveDevicesCount = mappedSlaveDevices && mappedSlaveDevices.length;

        if (!deviceKeys || deviceKeys.trim() === "") {
            currentErrors.deviceKeys = "Serial No. is required"
        }
        else if (mappedSlaveDevicesCount > 0) {
            if (slaveCountToConnect < (deviceKeysSize + mappedSlaveDevicesCount)) {
                currentErrors.deviceKeys = `Slave device limit exceeded (max: ${slaveCountToConnect}). Already ${mappedSlaveDevicesCount} devices mapped. You can only map ${slaveCountToConnect - mappedSlaveDevicesCount} devices.`
            }
        }
        else if (slaveCountToConnect < deviceKeysSize) {
            currentErrors.deviceKeys = `Slave device limit exceeded (max: ${slaveCountToConnect}).`
        }
        props.updateForm({
            formMapGroup: {
                ...form.formMapGroup,
            },
            errors: currentErrors,
        })
        if (Object.keys(currentErrors).length === 0) {
            props.mapNewDevice(form.formMapGroup, masterDeviceDetails.id);
        }
    };

    return isMapNewDevicePending ? (<VWLoading />) : (
        <Fragment>
            <form className="mb-3" name="formMapNewDevice">
                {errorMessage && (
                    <Message
                        type="danger"
                        defaultMessage={errorMessage}
                        baseClassName="alert"
                    />
                )}
                <FormGroup>
                    <Label>Master Device UID</Label>
                    <InputGroup>
                        <Input
                            type="text"
                            className='border border-secondary border-end-0'
                            name="masterDevicekey"
                            disabled
                            onChange={handleInputChange}
                            value={masterDeviceDetails.uid}
                        />
                        <Button
                            className='border border-secondary border-start-0'
                            color='light'
                            onClick={copyToClipboard}
                        >
                            <em className="fa fa-clipboard"></em>
                        </Button>
                    </InputGroup>
                </FormGroup>
                <FormGroup>
                    <Label>
                        New Serial Number(s)<span className="text-danger">*</span>
                    </Label>
                    <Input
                        autoFocus
                        type="textarea"
                        size='sm'
                        name="deviceKeys"
                        placeholder="Eg. 3; 5-8; 6,9"
                        onChange={handleInputChange}
                        invalid={form && form.errors && form.errors.deviceKeys}
                    />
                    <FormFeedback>{form && form.errors && form.errors.deviceKeys}</FormFeedback>
                    <span className="form-text">
                        <b>TIP :</b> You can add multiple devices by separating them with
                        comma or specify hyphen for range.
                        <br />
                    </span>
                </FormGroup>
                <FormGroup>
                    <Label >Group</Label>
                    <Async
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: "secondary"
                            })
                        }}
                        name="new_group"
                        placeholder="Select group"
                        defaultOptions
                        loadOptions={handleLoadGroups}
                        onChange={AddGroupChange}
                        openMenuOnFocus={true}
                    />
                </FormGroup>
            </form>
            <FormGroup>
                <Button
                    className="me-4"
                    size='sm'
                    color='success'
                    onClick={handleMapNewDevice}
                >Add Device
                </Button>
                <Button
                    size='sm'
                    color='danger'
                    onClick={handleClose}
                >Cancel
                </Button>
            </FormGroup>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    form: state.form.form,
    isMapNewDevicePending: state.deviceDetails.isMapNewDevicePending,
    mapNewErrorMessage: state.deviceDetails.mapNewDeviceErrorMessage,
    masterDeviceDetails: state.deviceDetails.masterDevice,
    errorMessage: state.deviceDetails.mapNewDeviceErrorMessage,
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (MapGroup) => dispatch(updateForm(MapGroup)),
    mapNewDevice: (MapGroup, masterDeviceId) => dispatch(mapNewDevice(MapGroup, masterDeviceId)),
    clearMapNewDeviceError: () => dispatch(clearMapNewDeviceError()),
    getAssignableGroupsForAsyncSelect: (masterDeviceId, searchValue, callback) =>
        dispatch(getAssignableGroupsForAsyncSelect(masterDeviceId, searchValue, callback)),
    copyMasterKeyToClipboard: (data) => dispatch(copyMasterKeyToClipboard(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(MapNewDeviceForm);
